import { STORAGE } from "./constants";

export interface FontScaleOption {
  id: string;
  label: string;
  scale: number;
}

/** 正文字号档位:CSS 侧用 --font-scale 乘数生效,阅读页/编辑面共用。 */
export const FONT_SCALES: readonly FontScaleOption[] = [
  { id: "small", label: "小", scale: 0.94 },
  { id: "normal", label: "标准", scale: 1 },
  { id: "large", label: "大", scale: 1.09 },
  { id: "xlarge", label: "特大", scale: 1.2 },
];

const DEFAULT_INDEX = 1;

export function resolveFontScale(savedId: string | null): FontScaleOption {
  return FONT_SCALES.find((option) => option.id === savedId) ?? FONT_SCALES[DEFAULT_INDEX]!;
}

export function nextFontScale(currentId: string | null): FontScaleOption {
  const index = FONT_SCALES.findIndex((option) => option.id === currentId);
  const base = index >= 0 ? index : DEFAULT_INDEX;
  return FONT_SCALES[(base + 1) % FONT_SCALES.length]!;
}

function applyFontScale(option: FontScaleOption): void {
  document.documentElement.style.setProperty("--font-scale", String(option.scale));
}

export function initFontScale(): void {
  applyFontScale(resolveFontScale(localStorage.getItem(STORAGE.fontScale)));
}

export function cycleFontScale(): FontScaleOption {
  const next = nextFontScale(resolveFontScale(localStorage.getItem(STORAGE.fontScale)).id);
  localStorage.setItem(STORAGE.fontScale, next.id);
  applyFontScale(next);
  return next;
}
